module.exports = {
          srcSet: __webpack_public_path__ + "9d9ab647a7e6f220a394c74f552a59f6-887.jpg"+" 887w",
          images:[ {path: __webpack_public_path__ + "9d9ab647a7e6f220a394c74f552a59f6-887.jpg",width: 887,height: 1577}],
          src: __webpack_public_path__ + "9d9ab647a7e6f220a394c74f552a59f6-887.jpg",
          toString:function(){return __webpack_public_path__ + "9d9ab647a7e6f220a394c74f552a59f6-887.jpg"},
          
          width: 887,
          height: 1577
        }